var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-layout',{attrs:{"crumbs":""}},[_c('ml-table',{attrs:{"fields":_vm.fields,"edit":"","delete":"","create":"","endpoint":"admin/downloads"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }